import React from "react";
import cx from "classnames";

import { DeliveryServiceAreaInfo } from "custom-types/Dispensary";
import { formatMaxTimeEstimate } from "utils/formatMaxTimeEstimate";

import Image from "components/Image";

type Props = {
  className?: string;
  deliveryServiceAreaRanges: {
    maxDeliveryDurationMaximum: number | null;
    maxOrderMinimum: number | null;
    maxFee: number | null;
  };
  /*  deliveryServiceAreaInfo is the delivery info for your exact address.
      It is returned in some cases from the finder-service /v3/dispensaries endpoint.
      We'll use this exact info when available, otherwise fall back to deliveryServiceAreaRanges.
  */
  deliveryServiceAreaInfo?: DeliveryServiceAreaInfo;
  hideDeliveryFee?: boolean;
};

const DotSeparator = () => (
  <span aria-hidden className="mx-sm">
    •
  </span>
);

const KeyDeliveryVariables: React.FC<Props> = ({
  className,
  deliveryServiceAreaRanges,
  deliveryServiceAreaInfo,
  hideDeliveryFee = false,
}) => {
  let fee;
  let orderMinimum;
  let time;
  if (deliveryServiceAreaInfo) {
    fee = deliveryServiceAreaInfo.fee;
    orderMinimum = deliveryServiceAreaInfo.orderMinimum;
    time = deliveryServiceAreaInfo.deliveryDurationMaximum;
  } else {
    fee = deliveryServiceAreaRanges.maxFee;
    orderMinimum = deliveryServiceAreaRanges.maxOrderMinimum;
    time = deliveryServiceAreaRanges.maxDeliveryDurationMaximum;
  }

  return (
    <section className={cx("flex items-center text-xs min-w-full", className)}>
      <span className="mr-sm" style={{ height: 16, width: 16 }}>
        <Image
          aria-hidden
          src="https://leafly-public.imgix.net/web-web/DeliveryScooterIcon.svg"
          sizes={[16]}
          ratio="square"
          alt="scooter icon"
        />
      </span>
      {time === null || orderMinimum === null || hideDeliveryFee ? (
        <span>Delivery Available</span>
      ) : (
        <>
          <span>{formatMaxTimeEstimate(time, "short")}</span>
          {orderMinimum >= 0 && (
            <>
              <DotSeparator /> <span> ${orderMinimum} min</span>
            </>
          )}
          <DotSeparator />
          <span>{!!fee && fee > 0 ? `$${fee} fee` : `Free delivery`}</span>
        </>
      )}
    </section>
  );
};

export default KeyDeliveryVariables;
